import { Creative } from '@synapex/shared2/gateway-rest-api'
import { InviteLinkWithAnalyticsType } from '../invite-links-group/invite-links-group.types'
import { SiteLinkWithAnalyticsType } from '../site-links-group/site-links-group.types'

export interface ICreative extends Creative.OneReply {}

type FilterNever<T> = {
    [K in keyof T as T[K] extends never ? never : K]: T[K]
}

type _Intersection<A, B> = A extends object
    ? B extends object
        ? Intersection<A, B>
        : A & B
    : A & B
type Intersection<A extends object, B extends object> = FilterNever<{
    [K in keyof A & keyof B]: A[K] extends B[K]
        ? B[K] extends A[K]
            ? A[K]
            : B[K]
        : _Intersection<A[K], B[K]>
}>

export type AnyLinkWithAnalyticsType = Intersection<
    Omit<SiteLinkWithAnalyticsType, 'site_link_id'>,
    Omit<InviteLinkWithAnalyticsType, 'invite_link_id'>
> & {
    site_link_id?: number
    invite_link_id?: number
}

export const QUERY_KEY = {
    creatives: 'creatives',
} as const
